import type { Schema } from './types'

export const shared: Schema = {
  'disable-app-banner': { default: false },
  'disable-cookie-banner': { default: false },
  'enable-sailthru': { default: true },
  'show-dev-widget': { default: false },
  'third-party-scripts': { default: true },
  'enable-google-one-tap': { default: false },
  'subscriptions-sign-up-component': { default: true },
} as const
